import React from 'react';
import { useSettings } from '../context/SettingsContext';

const Footer = () => {
  const { settings } = useSettings();

  return (
    <footer style={{
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      color: '#334155',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '1px solid #e2e8f0'
    }}>
      <div style={{ position: 'relative', zIndex: 2, padding: window.innerWidth <= 768 ? '40px 0 20px 0' : '50px 0 25px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 16px' }}>
          
          {/* Compact Links Grid */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))', 
            gap: window.innerWidth <= 768 ? '20px' : '30px',
            marginBottom: window.innerWidth <= 768 ? '30px' : '40px'
          }}>
            
            {/* Quick Links */}
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: window.innerWidth <= 768 ? '20px' : '24px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 15px rgba(6, 182, 212, 0.08)'
            }}>
              <h4 style={{ 
                fontSize: window.innerWidth <= 768 ? '1.2rem' : '1.3rem',
                fontWeight: '700',
                marginBottom: window.innerWidth <= 768 ? '16px' : '20px',
                color: '#06b6d4',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                🔗 Quick Links
              </h4>
              <div style={{ display: 'grid', gap: window.innerWidth <= 768 ? '10px' : '12px' }}>
                {[
                  { href: '/about', text: 'About Us', icon: '🏢' },
                  { href: '/contact', text: 'Contact Support', icon: '📞' },
                  { href: '/terms', text: 'Terms of Service', icon: '📄' },
                  { href: '/privacy', text: 'Privacy Policy', icon: '🔒' },
                  { href: '/refund', text: 'Refund Policy', icon: '💰' }
                ].map((link, index) => (
                  <a 
                    key={index}
                    href={link.href} 
                    style={{ 
                      color: '#64748b', 
                      textDecoration: 'none',
                      fontSize: '0.95rem',
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '8px 12px',
                      borderRadius: '8px'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.color = '#06b6d4';
                      e.target.style.background = 'rgba(6, 182, 212, 0.05)';
                      e.target.style.transform = 'translateX(5px)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.color = '#64748b';
                      e.target.style.background = 'transparent';
                      e.target.style.transform = 'translateX(0)';
                    }}
                  >
                    <span style={{ fontSize: '1.1rem' }}>{link.icon}</span>
                    {link.text}
                  </a>
                ))}
              </div>
            </div>

            {/* Categories */}
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: window.innerWidth <= 768 ? '20px' : '24px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 15px rgba(16, 185, 129, 0.08)'
            }}>
              <h4 style={{ 
                fontSize: window.innerWidth <= 768 ? '1.2rem' : '1.3rem',
                fontWeight: '700',
                marginBottom: window.innerWidth <= 768 ? '16px' : '20px',
                color: '#10b981',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                🎯 Categories
              </h4>
              <div style={{ display: 'grid', gap: window.innerWidth <= 768 ? '10px' : '12px' }}>
                {[
                  { icon: '🌳', text: 'Entry Tickets', color: '#06b6d4' },
                  { icon: '🅿️', text: 'Parking Tickets', color: '#10b981' },
                  { icon: '🙏', text: 'Puja Services', color: '#0891b2' },
                  { icon: '🎭', text: 'Events & Shows', color: '#059669' }
                ].map((category, index) => (
                  <div 
                    key={index}
                    style={{ 
                      color: '#64748b',
                      fontSize: '0.95rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '10px 12px',
                      background: `${category.color}08`,
                      borderRadius: '10px',
                      border: `1px solid ${category.color}20`,
                      transition: 'all 0.3s ease',
                      cursor: 'pointer'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'scale(1.02)';
                      e.currentTarget.style.background = `${category.color}15`;
                      e.currentTarget.style.color = category.color;
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.background = `${category.color}08`;
                      e.currentTarget.style.color = '#64748b';
                    }}
                  >
                    <span style={{ fontSize: '1.2rem' }}>{category.icon}</span>
                    <span style={{ fontWeight: '500' }}>{category.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Support */}
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: window.innerWidth <= 768 ? '20px' : '24px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 15px rgba(6, 182, 212, 0.08)'
            }}>
              <h4 style={{ 
                fontSize: window.innerWidth <= 768 ? '1.2rem' : '1.3rem',
                fontWeight: '700',
                marginBottom: window.innerWidth <= 768 ? '16px' : '20px',
                color: '#0891b2',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                🚀 Support
              </h4>
              <div style={{ display: 'grid', gap: window.innerWidth <= 768 ? '12px' : '16px' }}>
                <div style={{ 
                  background: 'linear-gradient(45deg, #06b6d408, #10b98108)',
                  padding: window.innerWidth <= 768 ? '12px' : '14px',
                  borderRadius: '10px',
                  border: '1px solid #06b6d420',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <span style={{ fontSize: window.innerWidth <= 768 ? '1.2rem' : '1.3rem' }}>📞</span>
                  <a href={`tel:${settings.supportPhone || '+91-9876543210'}`} style={{ 
                    color: '#06b6d4', 
                    textDecoration: 'none',
                    fontSize: window.innerWidth <= 768 ? '0.95rem' : '1rem',
                    fontWeight: '600'
                  }}>
                    {settings.supportPhone || '+91-9876543210'}
                  </a>
                </div>
                <div style={{ 
                  background: 'linear-gradient(45deg, #10b98108, #059669008)',
                  padding: window.innerWidth <= 768 ? '12px' : '14px',
                  borderRadius: '10px',
                  border: '1px solid #10b98120',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <span style={{ fontSize: window.innerWidth <= 768 ? '1.2rem' : '1.3rem' }}>📧</span>
                  <a href={`mailto:${settings.supportEmail || 'support@tiketjini.com'}`} style={{ 
                    color: '#10b981', 
                    textDecoration: 'none',
                    fontSize: window.innerWidth <= 768 ? '0.95rem' : '1rem',
                    fontWeight: '600'
                  }}>
                    {settings.supportEmail || 'support@tiketjini.com'}
                  </a>
                </div>
                <div style={{ 
                  background: 'linear-gradient(45deg, #0891b208, #06b6d408)',
                  padding: window.innerWidth <= 768 ? '12px' : '14px',
                  borderRadius: '10px',
                  border: '1px solid #0891b220',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: window.innerWidth <= 768 ? '1.2rem' : '1.3rem', marginBottom: '6px' }}>🕰️</div>
                  <div style={{ color: '#0891b2', fontSize: window.innerWidth <= 768 ? '0.95rem' : '1rem', fontWeight: '600' }}>
                    24/7 Customer Care
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Compact Bottom Section */}
          <div style={{ 
            paddingTop: window.innerWidth <= 768 ? '24px' : '30px', 
            borderTop: '1px solid #e2e8f0',
            textAlign: 'center'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: window.innerWidth <= 768 ? '10px' : '12px',
              marginBottom: window.innerWidth <= 768 ? '16px' : '18px'
            }}>
              <div style={{
                width: window.innerWidth <= 768 ? '40px' : '45px',
                height: window.innerWidth <= 768 ? '40px' : '45px',
                background: 'linear-gradient(45deg, #06b6d4, #10b981)',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 8px 25px rgba(6, 182, 212, 0.3)'
              }}>
                <img src="/Logo1.png" alt="Tiket Jini" style={{ width: window.innerWidth <= 768 ? '24px' : '28px', height: window.innerWidth <= 768 ? '24px' : '28px', borderRadius: '6px' }} />
              </div>
              <div>
                <div style={{ fontSize: window.innerWidth <= 768 ? '1.4rem' : '1.6rem', fontWeight: '800', color: '#06b6d4' }}>Tiket Jini</div>
                <div style={{ fontSize: window.innerWidth <= 768 ? '0.8rem' : '0.85rem', color: '#64748b' }}>Your Adventure Starts Here</div>
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <p style={{ 
                fontSize: window.innerWidth <= 768 ? '0.9rem' : '0.95rem',
                margin: '0 0 8px 0',
                background: 'linear-gradient(45deg, #06b6d4, #10b981, #0891b2)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontWeight: '500'
              }}>
                © {new Date().getFullYear()} Tiket Jini. All rights reserved. Made with ❤️
              </p>
              <p style={{
                fontSize: window.innerWidth <= 768 ? '0.8rem' : '0.85rem',
                margin: 0,
                color: '#94a3b8'
              }}>
                Powered by <span style={{ color: '#06b6d4', fontWeight: '600' }}>Bijdutronix Innovations</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;